// 中英文文案字典。$t('a.b.c') 取值，缺失时回退中文。
export const messages = {
  zh: {
    nav: {
      brand: '西安韦克德瑞人工智能',
      home: '首页',
      products: '产品',
      news: '荣誉与动态',
      about: '关于我们',
      switchTo: 'EN'
    },
    home: {
      eyebrow: 'VICTORY · 工业AI一体化解决方案提供商',
      ctaContact: '企业微信咨询',
      slides: [
        { title: '工业大模型，驱动制造业智能升级', description: '以工业大模型为核心，软硬一体，为能源、机械、化工等行业提供全场景AI解决方案。' },
        { title: '让AI听得懂工业、用得起大模型', description: '行业垂域大模型 + 边缘算力，支持企业本地部署，数据安全、降本增效。' },
        { title: '从智能运维到零碳园区', description: '覆盖智能诊断、工艺优化、电力交易、双碳管理等关键场景，助力高质量发展。' }
      ],
      visionHeadline: '工业AI一体化解决方案提供商',
      visionSub: '以工业大模型为核心，让人工智能成为传统制造业转型升级的核心引擎',
      pillars: [
        { title: '企业愿景', text: '成为人工智能技术在传统制造业转型升级中的赋能者，助力企业突破技术瓶颈、实现智能化生产，推动制造业高质量发展。' },
        { title: '经营理念', text: '创新驱动 · 技术引领 · 服务至上，不断探索AI与制造业深度融合的新模式、新路径，让先进技术真正落地见效。' },
        { title: '核心能力', text: '院士专家领衔，软硬一体，以工业大模型为核心，贯通算法、模型、硬件与场景，构建自主可控的技术壁垒。' }
      ],
      visionStat: '覆盖 <strong>60+</strong> 行业品类 · 市场空间大于 <strong>60</strong> 万亿',
      companyIntroTitle: '西安韦克德瑞人工智能科技有限公司',
      companyIntroSub: '深耕工业场景，让人工智能真正服务于生产、运营与管理',
      companyIntroParagraphs: [
        '西安韦克德瑞人工智能科技有限公司（简称“韦克德瑞”）是一家专注于工业人工智能技术研发与产业应用的科技企业，定位为工业AI一体化解决方案提供商。公司以工业大模型为核心，面向传统制造业和流程工业的数字化、智能化、低碳化需求，将人工智能算法、行业知识、工业软件、智能硬件与现场应用场景深度融合，为客户提供从需求分析、方案设计、产品部署到持续运营的一站式服务。韦克德瑞坚持让AI听得懂工业、看得懂设备、解决得了实际问题，帮助企业提升生产效率、设备可靠性、产品质量与经营管理水平。',
        '围绕工业AI核心技术，韦克德瑞形成了工业大模型、工业小模型、智能视觉、智能语音、智能软件、数字孪生、机器人、传感器和边缘算力等产品矩阵。公司自主打造PowerMind电力大模型、IndustMind工业大模型和OpsMind智能运维大模型，分别服务于能源电力、离散制造和通用设备运维等场景。相关能力覆盖工业知识问答、标准化操作校验、故障多维归因、事故应急辅助、工艺参数优化、工艺智能生成、加工质量预测、零件智能选型、异常识别、设备状态监测、故障诊断和寿命预测，让分散在专家经验、业务系统和设备数据中的知识转化为可复用的企业智能能力。',
        '在能源与电力领域，韦克德瑞提供电力现货交易、风电装备智能运维、热电厂智能运维、生物质燃料智能分析等产品，帮助客户提高预测与决策效率，降低非计划停机和运营成本。在机械与离散制造领域，公司围绕控制阀智能选型、机床加工质量预测、工艺参数优化、零件异常检测、多订单生产进度预测、地铁智能运维及工业机器人故障诊断等场景，推动生产过程透明化、质量管理前置化和设备维护主动化。在化工领域，公司提供脱硝精准喷氨和化工园区智能管控方案，兼顾生产效率、设备安全、环保合规与节能降耗。',
        '面向绿色低碳发展需求，韦克德瑞建设覆盖政府产业园区、企业和建筑场景的零碳园区及数字双碳管理产品体系。零碳园区解决方案能够对能源消耗和碳排放进行持续监测、智能核算、趋势分析与节能优化，帮助管理者看清能碳数据、识别减排空间、完善碳资产管理，并为园区绿色发展和企业低碳运营提供决策依据。同时，公司将数字孪生技术应用于关键设备健康评估、重载传动齿轮寿命预测和电站设备运维，通过虚实融合呈现设备状态与风险趋势，让检修计划更科学、运行管理更直观。',
        '为保障工业AI方案稳定落地，韦克德瑞具备软硬一体化交付能力，可结合机器人、自取能传感器、工业传感器、边缘计算分析盒和多档本地算力方案，为客户构建从数据采集、边缘分析到模型应用的完整链路。方案支持企业本地化部署，兼顾响应效率、数据安全与业务连续性。公司服务行业覆盖能源电力、煤矿、化工、机械、农业及其他工业领域，并持续联合高校实验室、行业专家和工程技术团队开展技术研发与场景验证。未来，西安韦克德瑞人工智能科技有限公司将继续以创新驱动、技术引领、服务至上为理念，推动工业大模型与实体产业深度融合，为制造业高质量发展和零碳园区建设提供可信、实用、可持续的工业AI产品与服务。'
      ],
      companyIntroTags: ['工业大模型', '智能运维', '数字孪生', '零碳园区', '机器人与传感器', '边缘算力'],
      matrixTitle: '核心产品矩阵',
      matrixSub: 'AI使能技术，软硬一体，构建工业智能化全栈能力',
      matrix: [
        { name: '工业大模型', label: '大模型', desc: '行业垂域大模型底座' },
        { name: '工业小模型', label: '小模型', desc: '轻量高效边缘智能' },
        { name: '智能视觉', label: '视觉', desc: '缺陷识别与视觉检测' },
        { name: '智能语音', label: '语音', desc: '语音交互与识别' },
        { name: '智能软件', label: '软件', desc: '行业智能软件平台' },
        { name: '数字孪生', label: '孪生', desc: '虚实融合仿真优化' },
        { name: '机器人', label: '机器人', desc: '巡检/特殊作业/物流' },
        { name: '传感器', label: '传感', desc: '自取能工业传感器' },
        { name: '边缘算力', label: '算力', desc: '本地化AI算力方案' }
      ],
      industriesTitle: '服务行业覆盖',
      industriesSub: 'AI技术赋能多行业智能化升级',
      industries: ['能源/电力', '煤矿', '化工', '机械', '农业', '其它工业'],
      strengthTitle: '科技创新 · 引领未来',
      strengthSub: '院士专家领衔，软硬一体的工业AI研发体系',
      statLabels: ['发明专利', '软件著作权', 'AI工程师', '研发人员占比', '省部级以上奖项', '覆盖行业品类']
    },
    products: {
      title: '产品与解决方案',
      subtitle: '以工业大模型为核心，按行业提供全场景AI解决方案',
      viewDetail: '查看详情'
    },
    detail: {
      gallerySeries: '产品系列',
      gallerySubDefault: '丰富型号，覆盖多种应用场景'
    },
    about: {
      title: '关于我们',
      subtitle: '工业AI一体化解决方案提供商',
      introTitle: '公司简介',
      introLead: '西安韦克德瑞人工智能科技有限公司是工业AI一体化解决方案提供商，以工业大模型为核心，致力于成为人工智能技术在传统制造业转型升级中的赋能者。',
      introText: '公司以“创新驱动、技术引领、服务至上”为理念，不断探索AI与制造业深度融合的新模式、新路径，助力企业突破技术瓶颈、实现智能化生产、提升市场竞争力，覆盖60+行业品类，市场空间大于60万亿。',
      introPoints: [
        '工业大模型 + 行业场景双轮驱动',
        '软硬一体化交付，支持本地部署',
        '覆盖能源、电力、机械、化工等核心行业',
        '从方案咨询到落地运营的一站式服务'
      ],
      qrTitle: '企业微信咨询',
      qrSubtitle: '扫码添加企业微信，获取产品资料与方案咨询',
      researchTitle: '研发体系',
      researchSub: '跨学科技术专家 + 行业资深工程师 + 学术研究顾问',
      researchTeams: [
        { count: '100+ AI工程师', title: '跨学科技术专家', desc: '涵盖AI算法、云计算、大数据、传感器、机器人等领域。' },
        { count: '20+ 行业专家', title: '行业资深工程师', desc: '具备10年以上行业经验，涉及能源、电力、机械、化工等领域。' },
        { count: '10+ 教授&研究员', title: '学术研究顾问', desc: '联合高校实验室开展前沿技术攻关。' }
      ],
      cultureTitle: '企业文化',
      cultureSub: '价值观驱动，使命引领',
      cultures: [
        { title: '愿景', description: '成为人工智能技术在传统制造业转型升级中的赋能者，推动制造业高质量发展。' },
        { title: '创新驱动', description: '持续探索AI与制造业深度融合的新模式、新路径，为传统制造业注入新活力。' },
        { title: '技术引领', description: '院士专家领衔，软硬一体，以工业大模型为核心构建核心技术壁垒。' },
        { title: '服务至上', description: '助力企业突破技术瓶颈、实现智能化生产、提升市场竞争力。' }
      ],
      certTitle: '资质与荣誉',
      certSub: '自主创新，硬核实力',
      certs: [
        { label: '发明专利', desc: '自主可控的核心算法' },
        { label: '软件著作权', desc: '完善的工程化落地能力' },
        { label: '团体标准', desc: '参与制定行业规范' },
        { label: '省部级以上奖项', desc: '院士专家团队领衔' }
      ]
    },
    news: {
      title: '荣誉与动态',
      subtitle: '科技创新 · 引领未来',
      videoEyebrow: '央视专访',
      videoTitle: '董事长刘宝生博士<br>接受央视董倩老师专访',
      videoDesc: '中央电视台董倩老师专访董事长刘宝生博士，分享韦克德瑞以工业大模型赋能传统制造业、推动新质生产力发展的创新实践与思考。',
      videoPoints: ['权威媒体深度报道', '工业AI创新实践分享', '赋能制造业高质量发展'],
      videoUnsupported: '您的浏览器不支持视频播放。',
      honorsTitle: '荣誉资质',
      honorsSub: '自主创新成果与行业认可',
      honors: [
        { title: '《信用中国》优秀实践案例', desc: '入选《信用中国》优秀实践案例，并获评年度科技创新与新质生产力公信力优秀实践案例。' },
        { title: '荣登《时代匠心》封面人物', desc: '刘宝生博士荣登《时代匠心》封面人物，彰显企业家创新精神。' },
        { title: '入选《中国科学家年鉴》', desc: '刘宝生博士入选《中国科学家年鉴》，获权威认可。' },
        { title: '昇腾AI创新大赛西北赛区决赛银奖', desc: '获奖项目：PowerMind 电力大模型。' },
        { title: '陕西昇腾生态创新中心年度案例集', desc: 'PowerMind 入选，体现电力垂域大模型与国产算力生态适配落地。' },
        { title: '受邀《人工智能产业高质量发展会议》', desc: '举办方：华为、雁塔人工智能创新发展中心。' }
      ],
      mediaTitle: '媒体报道',
      mediaSub: '权威媒体对公司技术创新与产业落地的深度报道'
    },
    footer: {
      rights: '西安韦克德瑞人工智能科技有限公司. 保留所有权利.',
      tagline: '工业AI · 大模型 · 智能运维'
    }
  },
  en: {
    nav: {
      brand: "XI'AN VICTORY AI",
      home: 'Home',
      products: 'Products',
      news: 'Honors & News',
      about: 'About Us',
      switchTo: '中文'
    },
    home: {
      eyebrow: 'VICTORY · Integrated Industrial AI Solution Provider',
      ctaContact: 'Contact via WeChat Work',
      slides: [
        { title: 'Industrial Large Models Power Smart Manufacturing', description: 'Built around industrial large models with integrated software and hardware, delivering full-scenario AI solutions for energy, machinery, chemicals and more.' },
        { title: 'Making AI Understand Industry and Making Large Models Practical', description: 'Vertical-domain large models plus edge computing support on-premises deployment, data security, cost reduction and efficiency gains.' },
        { title: 'From Intelligent Operations to Zero-Carbon Parks', description: 'Covering intelligent diagnosis, process optimization, power trading and dual-carbon management to support high-quality development.' }
      ],
      visionHeadline: 'Integrated Industrial AI Solution Provider',
      visionSub: 'Centered on industrial large models, making AI the core engine of transformation for traditional manufacturing',
      pillars: [
        { title: 'Vision', text: 'To be the enabler of AI in the transformation of traditional manufacturing, helping enterprises break technical bottlenecks, achieve intelligent production and drive high-quality development.' },
        { title: 'Philosophy', text: 'Innovation-driven, technology-led and service-first, continuously exploring new models and paths for deep AI-manufacturing integration so advanced technology truly delivers results.' },
        { title: 'Core Strength', text: 'Led by academicians and experts, with integrated software and hardware. Centered on industrial large models, we connect algorithms, models, hardware and scenarios into an independently controlled technical foundation.' }
      ],
      visionStat: 'Covering <strong>60+</strong> industry categories · Addressing a market exceeding <strong>RMB 60</strong> trillion',
      companyIntroTitle: "Xi'an Victory AI Technology Co., Ltd.",
      companyIntroSub: 'Deeply rooted in industrial scenarios, making AI work for production, operations and management',
      companyIntroParagraphs: [
        "Xi'an Victory AI Technology Co., Ltd. (Victory AI) is a technology company focused on industrial artificial intelligence R&D and real-world deployment. As an integrated industrial AI solution provider, we combine industrial large models, industry knowledge, intelligent software, smart hardware and operational scenarios to support the digital, intelligent and low-carbon transformation of traditional manufacturing and process industries.",
        'Our portfolio includes industrial large and small models, intelligent vision and speech, industrial software, digital twins, robots, sensors and edge computing. PowerMind, IndustMind and OpsMind serve power-industry, discrete-manufacturing and general equipment-operations scenarios, covering knowledge Q&A, operating-procedure verification, fault analysis, process optimization, quality prediction, anomaly detection, condition monitoring and remaining-life prediction.',
        'Victory AI serves energy and power, coal mining, chemicals, machinery, agriculture and other industrial sectors. Our solutions address power spot trading, wind and thermal power operations, intelligent manufacturing, chemical-park control and equipment diagnostics. We also provide zero-carbon park and carbon-management solutions for governments, industrial parks, enterprises and buildings, helping customers monitor energy use and emissions, improve carbon accounting and identify energy-saving opportunities.',
        'To ensure reliable deployment, we provide integrated software and hardware delivery supported by robots, energy-harvesting sensors, industrial sensors, edge analytics devices and on-premises computing. From data acquisition and edge analysis to model applications, Victory AI delivers a complete, secure and practical industrial intelligence chain that helps customers improve efficiency, quality, equipment reliability and sustainable operations.'
      ],
      companyIntroTags: ['Industrial Large Models', 'Intelligent Operations', 'Digital Twins', 'Zero-Carbon Parks', 'Robots & Sensors', 'Edge Computing'],
      matrixTitle: 'Core Product Matrix',
      matrixSub: 'AI-enabling technologies with integrated hardware and software for a full-stack industrial intelligence capability',
      matrix: [
        { name: 'Industrial Large Model', label: 'LLM', desc: 'Vertical-domain foundation model' },
        { name: 'Industrial Small Model', label: 'SLM', desc: 'Lightweight, efficient edge intelligence' },
        { name: 'Intelligent Vision', label: 'Vision', desc: 'Defect recognition & visual inspection' },
        { name: 'Intelligent Speech', label: 'Speech', desc: 'Voice interaction & recognition' },
        { name: 'Intelligent Software', label: 'Software', desc: 'Industry intelligent software platform' },
        { name: 'Digital Twin', label: 'Twin', desc: 'Virtual-real fusion & optimization' },
        { name: 'Robots', label: 'Robot', desc: 'Inspection / special ops / logistics' },
        { name: 'Sensors', label: 'Sensor', desc: 'Energy-harvesting industrial sensors' },
        { name: 'Edge Computing', label: 'Compute', desc: 'On-premises AI computing solutions' }
      ],
      industriesTitle: 'Industries We Serve',
      industriesSub: 'AI empowering intelligent upgrades across industries',
      industries: ['Energy / Power', 'Coal Mining', 'Chemicals', 'Machinery', 'Agriculture', 'Other Industries'],
      strengthTitle: 'Innovation · Leading the Future',
      strengthSub: 'An industrial AI R&D system led by academicians, integrating software and hardware',
      statLabels: ['Invention Patents', 'Software Copyrights', 'AI Engineers', 'R&D Staff Ratio', 'Provincial-Level or Higher Awards', 'Industry Categories']
    },
    products: {
      title: 'Products & Solutions',
      subtitle: 'Centered on industrial large models, delivering full-scenario AI solutions by industry',
      viewDetail: 'View Details'
    },
    detail: {
      gallerySeries: 'Product Series',
      gallerySubDefault: 'A rich range of models for diverse applications'
    },
    about: {
      title: 'About Us',
      subtitle: 'Integrated Industrial AI Solution Provider',
      introTitle: 'Company Profile',
      introLead: "Xi'an Victory AI Technology Co., Ltd. is an integrated industrial AI solution provider. Centered on industrial large models, we are committed to becoming the enabler of AI in the transformation of traditional manufacturing.",
      introText: 'Guided by the philosophy of "innovation-driven, technology-led and service-first", we continuously explore new models and paths for deep AI-manufacturing integration, helping enterprises break technical bottlenecks, achieve intelligent production and enhance competitiveness. Our solutions cover 60+ industry categories and address a market exceeding RMB 60 trillion.',
      introPoints: [
        'Dual engine of industrial large models and industry scenarios',
        'Integrated hardware-software delivery with on-premises support',
        'Covering energy, power, machinery, chemicals and other core industries',
        'One-stop service from consulting to deployment and operation'
      ],
      qrTitle: 'Contact via WeChat Work',
      qrSubtitle: 'Scan to add our WeChat Work for product materials and consultation',
      researchTitle: 'R&D System',
      researchSub: 'Interdisciplinary technical experts + senior industry engineers + academic advisors',
      researchTeams: [
        { count: '100+ AI Engineers', title: 'Interdisciplinary Experts', desc: 'Spanning AI algorithms, cloud computing, big data, sensors and robotics.' },
        { count: '20+ Industry Experts', title: 'Senior Industry Engineers', desc: 'With 10+ years of experience across energy, power, machinery and chemicals.' },
        { count: '10+ Professors & Researchers', title: 'Academic Advisors', desc: 'Conducting frontier R&D jointly with university laboratories.' }
      ],
      cultureTitle: 'Corporate Culture',
      cultureSub: 'Values-driven, mission-led',
      cultures: [
        { title: 'Vision', description: 'To be the enabler of AI in the transformation of traditional manufacturing and to drive its high-quality development.' },
        { title: 'Innovation-Driven', description: 'Continuously exploring new models and paths for deep AI-manufacturing integration, energizing traditional manufacturing.' },
        { title: 'Technology-Led', description: 'Led by academicians and experts, with integrated hardware and software, building core capabilities around industrial large models.' },
        { title: 'Service-First', description: 'Helping enterprises break technical bottlenecks, achieve intelligent production and enhance market competitiveness.' }
      ],
      certTitle: 'Qualifications & Honors',
      certSub: 'Independent innovation, proven technical strength',
      certs: [
        { label: 'Invention Patents', desc: 'Autonomous, controllable core algorithms' },
        { label: 'Software Copyrights', desc: 'Solid engineering and delivery capability' },
        { label: 'Group Standards', desc: 'Contributing to industry standards' },
        { label: 'Provincial-Level or Higher Awards', desc: 'Led by an academician-expert team' }
      ]
    },
    news: {
      title: 'Honors & News',
      subtitle: 'Innovation · Leading the Future',
      videoEyebrow: 'CCTV Interview',
      videoTitle: 'Chairman Dr. Liu Baosheng<br>Interviewed by CCTV Host Dong Qian',
      videoDesc: "CCTV host Dong Qian interviews Chairman Dr. Liu Baosheng, sharing Victory's innovative practice of empowering traditional manufacturing with industrial large models and advancing new quality productive forces.",
      videoPoints: ['In-depth coverage by authoritative media', 'Sharing industrial AI innovation', 'Empowering high-quality manufacturing'],
      videoUnsupported: 'Your browser does not support video playback.',
      honorsTitle: 'Honors & Qualifications',
      honorsSub: 'Independent innovation achievements and industry recognition',
      honors: [
        { title: 'Credit China Best Practice Case', desc: 'Selected as a Credit China best practice case and recognized as an outstanding annual case for tech innovation and new quality productive forces.' },
        { title: 'Cover Figure of "Craftsmanship of the Times"', desc: 'Dr. Liu Baosheng featured on the cover of "Craftsmanship of the Times", reflecting entrepreneurial innovation.' },
        { title: 'Listed in "Yearbook of Chinese Scientists"', desc: 'Dr. Liu Baosheng listed in the "Yearbook of Chinese Scientists" with authoritative recognition.' },
        { title: 'Silver Award, Ascend AI Innovation Contest (Northwest Regional Final)', desc: 'Winning project: PowerMind Power Industry Large Model.' },
        { title: 'Shaanxi Ascend Ecosystem Annual Case Collection', desc: 'PowerMind selected, demonstrating domain LLM and domestic computing ecosystem adaptation.' },
        { title: 'Invited to the "AI Industry High-Quality Development Conference"', desc: 'Hosted by Huawei and Yanta AI Innovation & Development Center.' }
      ],
      mediaTitle: 'Media Coverage',
      mediaSub: 'In-depth reports by authoritative media on our innovation and industrial implementation'
    },
    footer: {
      rights: "Xi'an Victory AI Technology Co., Ltd. All rights reserved.",
      tagline: 'Industrial AI · Large Models · Intelligent O&M'
    }
  }
}
